import {Component} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatError} from '@angular/material/form-field';
import {FieldType, FieldTypeConfig, FormlyValidationMessage} from '@ngx-formly/core';
import {EditorComponent, TINYMCE_SCRIPT_SRC} from '@tinymce/tinymce-angular';

@Component({
  standalone: true,
  selector: 'app-tinymce',
  imports: [EditorComponent, FormsModule, ReactiveFormsModule, MatError, FormlyValidationMessage],
  providers: [{provide: TINYMCE_SCRIPT_SRC, useValue: 'js/tinymce/tinymce.min.js'}],
  templateUrl: './tinymce.component.html',
})
export class TinymceComponent extends FieldType<FieldTypeConfig> {
  init: EditorComponent['init'] = {
    plugins: 'lists link image table code preview',
    menubar: false,
    license_key: 'e6xej1twjkrwurtmyh0con2fgt11ufwtyfeqnwin57ud8r65',
    toolbar: [
      'undo redo | bold italic underline link blockquote forecolor backcolor h3 h4 removeformat styles | indent outdent alignleft aligncenter alignright alignjustify | bullist numlist tableinsertdialog image | table | code | preview',
    ],
    formats: {
      bold: {inline: 'b', remove: 'all'},
      italic: {inline: 'i', remove: 'all'},
      underline: {inline: 'u', remove: 'all'},
    },
    base_url: '/js/tinymce',
    plugin_url: '/js/tinymce/plugins',
    suffix: '.min',
    promotion: false,
    onboarding: false,
    branding: false,
    relative_urls: false,
    link_default_target: '_self',
    remove_script_host: true,
    table_class_list: [
      {title: 'None', value: ''},
      {title: 'Standard Table Style', value: 'standard-table'},
    ],
    document_base_url: globalThis.origin,
    valid_elements:
      '@[class|style|title],a[download|href|name|rel|target],b/strong,blockquote,br,div,i/emp,h3,h4,hr,img[alt|height|src|width],li,ol,p,pre,span,sub,sup,table,tbody,td[colspan|rowspan],th/thead[colspan|rowspan],tbody,thead,tr,u,ul',
    valid_styles: {
      '*': 'background-color,border,border-bottom,border-color,border-left,border-right,border-style,border-top,border-width,color,height,list-style,list-style-type,margin-left,max-height,max-width,padding-left,padding,padding-right,padding-top,padding-bottom,text-align,text-indent,text-transform,text-underline,transform,width',
      table: 'background-color,border,border-bottom,border-top,border-left,border-right,padding,vertical-align',
      td: 'background-color,border,border-bottom,border-top,border-left,border-right,padding,vertical-align',
      th: 'background-color,border,border-bottom,border-top,border-left,border-right,padding,vertical-align',
    },
    style_formats: [{title: 'Standard Table Style', selector: 'table', classes: 'standard-table'}],
    content_css: '/css/tinymce-content.css',
    importcss_append: true,
    automatic_uploads: false,
    convert_urls: false,
    images_dataimg_filter: () => true,
    urlconverter_callback: (url: string) => url,
    setup: (editor: any) => {
      const replaceBlobUris = (html: string): string =>
        html.replace(/src="(blob:[^"]+)"/g, (_match: string, blobUri: string) => {
          const blobInfo = editor.editorUpload?.blobCache?.getByUri(blobUri);
          if (blobInfo) {
            return `src="data:${blobInfo.blob().type};base64,${blobInfo.base64()}"`;
          }
          return `src="${blobUri}"`;
        });

      editor.on('GetContent', (e: any) => {
        if (e.format === 'html') {
          e.content = replaceBlobUris(e.content);
        }
      });

      editor.on('Change input', () => {
        const html = editor.getContent();
        const resolved = replaceBlobUris(html);
        if (resolved !== html) {
          editor.setContent(resolved, {no_events: true});
          editor.selection.setCursorLocation();
        }
      });
    },
  };
}
